// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "7284acd7a161b9c8","796": "a1c0f4e3c68c947e",}[chunkId] + ".js"
}